import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export function useZendeskSetup() {
  const { i18n } = useTranslation();

  useEffect(() => {
    if (window.zE) {
      try {
        // used for the new zendesk widget
        window.zE("messenger:set", "locale", i18n.language);
      } catch {
        // used for the old (classic) zendesk widget, this is
        // used by legacy portal.
        window.zE("webWidget", "setLocale", i18n.language);
      }
    }
  }, [i18n.language]);
}
